import React from 'react'

export const AboutFeatureItem = ({item}) => {

    return (
        <li>
            <div className={`iconic ${item.edit ? 'edit': ''}`}>
                {item.symbol}
            </div>
            <div className="detail">
                <h5 className="title">{item.title}</h5>
                {item.description && <p className="description">{item.description}</p>}
            </div>
        </li>
    )
}

 